/**
 * 时间处理工具函数
 */

/**
 * 格式化时间
 * @param date Date对象、时间戳或YYYY/MM/DD hh:mm:ss格式的字符串
 * @returns 格式化后的字符串
 * - 今天：今天 hh:mm:ss
 * - 昨天：昨天 hh:mm:ss
 * - 其他：YYYY/MM/DD hh:mm:ss
 */
export function formatTime(date: Date | number | string): string {
  let d: Date
  if (typeof date === 'number') {
    d = new Date(date)
  } else if (typeof date === 'string') {
    d = new Date(date.replace(/-/g, '/'))
  } else {
    d = date
  }

  const now = new Date()
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const yesterdayStart = new Date(todayStart.getTime() - 24 * 60 * 60 * 1000)

  if (d >= todayStart) {
    return `今天 ${d.toTimeString().slice(0, 8)}`
  } else if (d >= yesterdayStart) {
    return `昨天 ${d.toTimeString().slice(0, 8)}`
  } else {
    return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')} ${d.toTimeString().slice(0, 8)}`
  }
}

/**
 * 格式化持续时间
 * @param ms 毫秒数
 * @returns 格式化的持续时间字符串
 */
export function formatDuration(ms: number): string {
  if (ms >= 1000) {
    return `${(ms / 1000).toFixed(1)}s`
  }
  return `${ms.toFixed(0)}ms`
}

/**
 * 格式化相对时间
 * @param date 时间
 * @returns 相对时间字符串，如 "2分钟前"、"1小时前"
 */
export function formatRelativeTime(date: Date | number | string): string {
  const d = typeof date === 'string' ? new Date(date) : new Date(date)
  const now = new Date()
  const diff = now.getTime() - d.getTime()

  const minute = 60 * 1000
  const hour = 60 * minute
  const day = 24 * hour
  const week = 7 * day
  const month = 30 * day
  const year = 365 * day

  if (diff < minute) {
    return '刚刚'
  } else if (diff < hour) {
    return `${Math.floor(diff / minute)}分钟前`
  } else if (diff < day) {
    return `${Math.floor(diff / hour)}小时前`
  } else if (diff < week) {
    return `${Math.floor(diff / day)}天前`
  } else if (diff < month) {
    return `${Math.floor(diff / week)}周前`
  } else if (diff < year) {
    return `${Math.floor(diff / month)}个月前`
  } else {
    return `${Math.floor(diff / year)}年前`
  }
}

/**
 * 生成时间标签数组
 * @param count 标签数量
 * @param intervalMs 间隔毫秒数，默认2秒
 * @returns 时间标签数组
 */
export function generateTimeLabels(count: number, intervalMs = 2000): string[] {
  const labels = []
  const now = Date.now()
  for (let i = count - 1; i >= 0; i--) {
    const time = new Date(now - i * intervalMs).toLocaleTimeString('zh-CN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
    labels.push(time)
  }
  return labels
}
